import * as React from "react";
import { cn } from "../../lib/utils";
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
    return (<textarea className={cn("va-textarea", className)} ref={ref} {...props}/>);
});
Textarea.displayName = "Textarea";
export { Textarea };
